export class CONADriverPayloadRequest {
    RequestID: number;
    MyCustomColumn: string;
}

export default CONADriverPayloadRequest;